<template>
<v-card>
    <SmallLoaderLight v-if="!profiles" />
    <v-card-text v-else>
        <v-text-field label="type usernames" v-model="filter" @keydown="searchProfiles"></v-text-field>
        <div class="profiles-list">
            <template>
                <SmallProfileCard v-for="p in filteredProfiles" :profile="p" :key="p" :event_id="event_id" :event_slug="event_slug" />
            </template>
        </div>
    </v-card-text>
</v-card>
</template>

<script>
import SmallLoaderLight from "@/components/atoms/SmallLoaderLight";
import SmallProfileCard from "@/components/atoms/SmallProfileCard";
import {
    mapState
} from "vuex";

export default {
    components: {
        SmallLoaderLight,
        SmallProfileCard,
    },
    props: ["event_id", "event_slug"],
    data() {
        return {
            filter: "",
        };
    },
    computed: mapState({
        profiles: (state) => state.profiles.profilesToInvite,
        filteredProfiles(state) {
            if (this.filter === "") return state.profiles.profilesToInvite;
            else
                return state.profiles.profilesToInvite.filter((e) =>
                    e.username.toLowerCase().includes(this.filter.toLowerCase())
                );
        },
    }),
    methods: {
        searchProfiles() {
            this.$store.dispatch(
                "getSearchProfiles",
                this.filter + "&event_to_invite=" + this.event_id
            );
        },
    },
    mounted() {
        if (this.event_id) this.$store.dispatch("getProfileToInvite", this.event_id);
    },
};
</script>
